import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userTypeSlice from "./Slices/userTypeSlice";
import subscriptionSlice from "./Slices/subscriptionSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import contactSlice from "./Slices/contactSlice";
import projectSlice from "./Slices/projectSlice";
import projectDetailsSlice from "./Slices/projectDetailsSlice";
import DischargeConditionSlice from "./Slices/DischargeConditionSlice";
import programmeSlice from "./Slices/ProgrammeSlice";
import todoSlice from "./Slices/todoSlice";
import tenderSlice from "./Slices/tenderSlice";
import taskSlice from "./Slices/taskSlice";
import permissionSlice from "./Slices/permissionSlice";
import projectSpendingSlice from "./Slices/HeyTraderSlices/ProjectSpendingSlice";
import projectSpendingShopSlice from "./Slices/HeyTraderSlices/ProjectSpendingShopSlice";
import clientAccountSlice from "./Slices/HeyTraderSlices/ClientAccountSliceState";
import clientAccountCompanySlice from "./Slices/HeyTraderSlices/ClientAccountCompanySliceState";
import materialProjectSlice from "./Slices/HeyTraderSlices/MaterialProjectSliceState";
import materialUnitSlice from "./Slices/HeyTraderSlices/MaterialUnitSliceState";
import materialCategorySlice from "./Slices/HeyTraderSlices/MaterialCategorySliceState";
import materialTemplate from "./Slices/HeyTraderSlices/MaterialTemplateSliceState";
import contactEmployeeSlice from "./Slices/HeyTraderSlices/ContactEmployeeSliceState";
import attendanceEmployeeSlice from "./Slices/HeyTraderSlices/AttendanceEmployeeSliceState";
import attendanceTakenSlice from "./Slices/HeyTraderSlices/AttendanceTakenSliceState";
import attendanceSingleEmployeeSlice from "./Slices/HeyTraderSlices/AttendanceSingleEmployeeSliceState";
import toolCategorySlice from "./Slices/HeyTraderSlices/ToolCategorySliceState";
import toolTypeSlice from "./Slices/HeyTraderSlices/ToolTypeSliceState";
import toolBrandslice from "./Slices/HeyTraderSlices/ToolBrandSliceState";
import toolStorageslice from "./Slices/HeyTraderSlices/ToolStorageSliceState";
import toolListSlice from "./Slices/HeyTraderSlices/ToolSliceState";
import commonProjectSlice from "./Slices/HeyTraderSlices/CommonProjectSliceState";
import attendanceHomeSlice from "./Slices/HeyTraderSlices/AttendanceHomeListSliceState";
import DevelopmentAppraisalSlice from "./Slices/DevelopmentAppraisal/DevelopmentAppraisalStateSlice";
import mysubscriptionSlice from "./Slices/SiteMenuSlices/MySubscriptionSliceState";
import paymentHistorySlice from "./Slices/SiteMenuSlices/PaymentHistorySliceState";
import paymentSlice from "./Slices/PaymentSlice/PaymentSliceState";
import sharedFolderSlice from "./Slices/ProjectSlice/ProjectSharedFolderSliceState";
import tenderCompareSlice from "./Slices/TenderCompareSliceState";
import valuationEditSlice from "./Slices/ValuationEditSliceState";
import quickAccessSlice from "./Slices/Home/QuickAccessSliceState";
import planCheckSlice from "./Slices/PlanCheck/PlanCheckSliceState";
import planCheckTrackerSlice from "./Slices/PlanCheck/PlanCheckTrackerSliceState";
import siteVisitSlice from "./Slices/SiteVisit/SiteVisitSliceState";
import initialNoticeSlice from "./Slices/InitialNoties/InitialNoticeSliceState";
import dutyHolderSlice from "./Slices/DutyHolder/DutyHolderSliceState";
import commencementNotificationSlice from "./Slices/CommencementNotification/CommencementNotificationSliceState";
import complianceDeclarationSlice from "./Slices/ComplianceDeclaration/ComplianceDeclarationSliceState";
import contactAreaSlice from "./Slices/Contact/ContactAreaSliceState";
import quotationSlice from "./Slices/QuotationSlices/QuotationSlice";
import newPermissionSlice from "./Slices/NewPermissionSliceState";
import attendanceProjectSlice from "./Slices/HeyTraderSlices/AttendanceProjectSliceState";
import buildingControlSlice from "./Slices/BuildingControl/BuildingControlSlice";
import finishingScheduleSlice from "./Slices/FinishingSchedule/FinishingScheduleSlice";
import newAttendanceEmployeeSlice from "./Slices/NewAttendanceSlice/NewAttendanceEmployeeSliceState";
import newAttendanceExpenseSlice from "./Slices/NewAttendanceSlice/NewAttendanceExpenseSliceState";
import newAttendanceHomeSlice from "./Slices/NewAttendanceSlice/NewAttendanceHomeSliceState";
import newAttendanceProjectSlice from "./Slices/NewAttendanceSlice/NewAttendanceProjectSliceState";
import newAttendanceViewDetailSlice from "./Slices/NewAttendanceSlice/NewAttendanceViewDetailSliceState";
import siteVisitReportSlice from "./Slices/SiteVisitReport/SiteVisitReportSliceState";
import siteInspectionBookingSlice from "./Slices/SiteInspectionBooking/SiteInspectionBookingSliceState";

import layoutSlice from "./Slices/layoutSlice";

const persistConfig = {
  key: "root",
  storage,
};

const appReducer = combineReducers({
  userTypes: userTypeSlice,
  subscriptions: subscriptionSlice,
  contact: contactSlice,
  project: projectSlice,
  projectDetails: projectDetailsSlice,
  dischargeCondition: DischargeConditionSlice,
  programme: programmeSlice,
  todo: todoSlice,
  tender: tenderSlice,
  task: taskSlice,
  permission: permissionSlice,
  projectSpending: projectSpendingSlice,
  projctSpendingShops: projectSpendingShopSlice,
  clientAccount: clientAccountSlice,
  materialProject: materialProjectSlice,
  materialCategory: materialCategorySlice,
  clientAccountCompany: clientAccountCompanySlice,
  materialUnit: materialUnitSlice,
  materialTemplates: materialTemplate,
  contactEmployees: contactEmployeeSlice,
  attendanceEmployees: attendanceEmployeeSlice,
  attendanceTaken: attendanceTakenSlice,
  attendanceHome: attendanceHomeSlice,
  attendanceSingleEmployee: attendanceSingleEmployeeSlice,
  toolCategories: toolCategorySlice,
  toolTypes: toolTypeSlice,
  toolBraands: toolBrandslice,
  toolStorages: toolStorageslice,
  toolsList: toolListSlice,
  commonProjectList: commonProjectSlice,
  developmetAppraisalList: DevelopmentAppraisalSlice,
  mySubscriptionList: mysubscriptionSlice,
  paymentHistory: paymentHistorySlice,
  paymentInstalment: paymentSlice,
  shareFolderList: sharedFolderSlice,
  tenderCompareList: tenderCompareSlice,
  valuationEditSlice: valuationEditSlice,
  quickAccessList: quickAccessSlice,
  planCheckList: planCheckSlice,
  planCheckTrackerList: planCheckTrackerSlice,
  siteVisitList: siteVisitSlice,
  initialNotice: initialNoticeSlice,
  dutyHolderDetails: dutyHolderSlice,
  commencementNotificationDetails: commencementNotificationSlice,
  complianceDeclarationDetails: complianceDeclarationSlice,
  contactAreaList: contactAreaSlice,
  quotationList: quotationSlice,
  newPermission: newPermissionSlice,
  attendanceProjects: attendanceProjectSlice,
  buildingControl: buildingControlSlice,
  finishingSchedule: finishingScheduleSlice,
  newAttendanceProject: newAttendanceProjectSlice,
  newAttendanceViewDetail: newAttendanceViewDetailSlice,
  newAttendanceHome: newAttendanceHomeSlice,
  newAttendanceExpense: newAttendanceExpenseSlice,
  newAttendanceEmployee: newAttendanceEmployeeSlice,
  layout: layoutSlice,
  siteVisitReport: siteVisitReportSlice,
  siteInspectionBooking: siteInspectionBookingSlice,
});

// Add root reducer with RESET handling
const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET") {
    state = undefined; // reset all slices to their initial state
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiMiddleware),
});

//export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
